export function parseWords(text: string): string[] {
  return text
    .split(',')
    .map((s) => s.trim())
    .filter((s) => s.length > 0)
}

export function groupByFirstLetter(words: string[]): Map<string, string[]> {
  const groups = new Map<string, string[]>()
  for (const w of words) {
    const first = w[0]?.toUpperCase() ?? ''
    if (!/^[A-Z]$/.test(first)) continue
    const list = groups.get(first) ?? []
    list.push(w)
    groups.set(first, list)
  }
  return new Map([...groups.entries()].sort(([a], [b]) => a.localeCompare(b)))
}
